import {useEffect, useState} from "react";
import {findEvents} from "../api/apiClient";

export const useEvents = (choosedDate, reloadTrigger) => {
    const [events, setEvents] = useState([]);
    const [continuousEventDates, setContinuousEventDates] = useState([]);
    const [weekDates, setWeekDates] = useState([]);
    const [prevWeekDate, setPrevWeekDate] = useState(null);
    const [nextWeekDate, setNextWeekDate] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const events = findEvents(choosedDate, abortController.signal);

        events
            .then(
                (data) => {
                    const events = data.events;
                    const continuousEventDates = data.continuousEventDates;
                    const weekDates = data.weekDates;
                    const prevWeekDate = data.prevWeekDate;
                    const nextWeekDate = data.nextWeekDate;

                    setEvents(events)
                    setContinuousEventDates(continuousEventDates)
                    setWeekDates(weekDates)
                    setPrevWeekDate(prevWeekDate)
                    setNextWeekDate(nextWeekDate)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [choosedDate, reloadTrigger]);

    return {events, continuousEventDates, weekDates, prevWeekDate, nextWeekDate};
};